import { QueryParamsBase } from './query-params-base';

export function assertIsQueryParamsBased(query: unknown): asserts query is QueryParamsBase<any> {
	if (query instanceof QueryParamsBase)
		return;

	throw new Error('Provided value is not query params based');
}
